<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' :items='vendedor' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(color='primary' dark)
            v-toolbar-title.justify-center Vendedor
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
              v-dialog(v-model='dialog' scrollable persistent max-width='80%')
                //-template(v-slot:activator='{ on }')
                  v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' v-on='on')
                    v-icon(dark) mdi-plus
                v-card(color='grey_1')
                  v-app-bar(dark color='primary')
                    v-toolbar-title.headline {{ formTitle }}
                  v-card-text
                    v-row(dense)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Información del Vendedor
                          v-card-text
                            v-row(dense)
                              v-col(cols='12' sm='6' md='4')
                                v-text-field(dense outlined v-model='editedItem.cedula' :readonly='read' label='Cedula')
                              v-col(cols='12' sm='6' md='4')
                                v-text-field(dense outlined v-model='editedItem.nombre' :readonly='read' label='Nombre' v-mask="'AAAAAAAAAAAAAAAAAAAAAA'")
                              v-col(cols='12' sm='6' md='4')
                                v-text-field(dense outlined v-model='editedItem.apellido' :readonly='read' label='Apellido' v-mask="'AAAAAAAAAAAAAAAAAAAAAA'")
                              v-col(cols='12' sm='6' md='6' class='d-flex justify-center')
                                v-text-field(dense outlined v-model='editedItem.codZona.descripcion' :readonly='read' label='Zona')
                              v-col(cols='12' sm='6' md='6' class='d-flex justify-center')
                                v-text-field(dense outlined v-model='editedItem.codRuta.descripcion' :readonly='read' label='Ruta Asociada')
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Portafolios Asociados
                          v-card-text
                            v-row(dense)
                              v-col(cols='12' sm='6' md='12')
                                v-data-table.elevation-1(:headers='headVendedor' hide-default-footer :items='editedItem.codPortafolio')
                      p
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Clientes Asociados al Vendedor
                          v-card-text
                            v-row(dense)
                              v-dialog(ref='dialog2', persistent='', max-width='40%')
                                template(v-slot:activator='{ on }' class='d-flex justify-end')
                                  v-btn(:disabled="!mostrar" @click='exportPDF()' small color='red')
                                    v-icon(color='white') mdi-pdf-box
                              v-col(cols='12' sm='6' md='12')
                                v-data-table.elevation-1(:headers='headCliente' hide-default-footer :items='rutaCliVen')
                                  template(v-slot:no-data)
                                    h1 No hay datos de clientes asociados a la ruta
                  v-card-actions
                    v-spacer
                    v-btn(color='error' small dark @click='close')
                      v-icon mdi-close
                      | Salir

        //-template(slot='items' slot-scope='props')
          td {{ }}
          td.text-xs-right {{}}
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item, true)' v-on="on") mdi-eye
            | Visualizar
        template(v-slot:no-data)
          h1 No hay datos de Vendedores Asociados
</template>

<script>
import Api from '@/services/methods'

import Jspdf from 'jspdf'
import JspdfAutotable from 'jspdf-autotable'

export default {
  name: 'pdf',

  prop: ['read'],
  data: () => ({
    dialog: false,
    dialog2: false,
    read: false,
    loading: true,
    mostrar: false,

    headers: [
      { text: 'Cedula', align: 'left', value: 'cedula' },
      { text: 'Apellido', value: 'apellido' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Zona', value: 'codZona.descripcion' },
      { text: 'Ruta', value: 'codRuta.descripcion' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    headVendedor: [
      { text: 'Codigo', align: 'center', value: 'codPortafolio', sortable: false },
      { text: 'Descripcion', align: 'center', value: 'descripcion', sortable: false }
    ],
    headCliente: [
      { text: 'Rif', align: 'center', value: 'rif', sortable: false },
      { text: 'Nombre', align: 'center', value: 'nombre', sortable: false },
      { text: 'Total Deuda', value: 'deuda', sortable: false }
    ],
    vendedor: [],
    rutaCliVen: [],
    cliente: [],
    cxc: [],
    cxc2: [],

    /* ruta: [],
    idRutaArray: [],

    portafolio: [],
    idPortafolioArray: [], */

    search: '',
    permisosRuta: {},
    editedIndex: -1,
    editedItem: {
      cedula: '',
      apellido: '',
      nombre: '',
      codZona: '',
      codRuta: '',
      codPortafolio: []
    },
    defaultItem: {
      cedula: '',
      apellido: '',
      nombre: '',
      codZona: '',
      codRuta: '',
      codPortafolio: []
    }
  }),

  components: {
    JspdfAutotable
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Vendedor'
        : this.read
          ? 'Detalles'
          : 'Modificar Vendedor'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    exportPDF () {
      var today = new Date()
      var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()

      var columns = [
        { title: 'N° Factura', dataKey: 'numF' },
        { title: 'Fecha Registro', dataKey: 'fechaR' },
        { title: 'Fecha Vencimiento', dataKey: 'fechaV' },
        { title: 'Días Deuda', dataKey: 'diasD' },
        { title: 'Observación', dataKey: 'observacion' },
        { title: 'Neto', dataKey: 'neto' },
        { title: 'Saldo', dataKey: 'saldo' }
      ]

      let contenido = []
      let acumTotal = 0
      let acumNeto = 0

      var doc = new Jspdf('l', 'pt')
      for (let i = 0; i < this.rutaCliVen.length; i++) {
        for (let j = 0; j < this.cxc2.length; j++) {
          if (this.rutaCliVen[i].id === this.cxc2[j].idCliente._id) {
            this.decimal(this.cxc2[j].debito)
            this.decimal(this.cxc2[j].credito)
            let fechaRe = this.formato2(this.cxc2[j].fechaRegistro)
            let fechaVe = this.formato2(this.cxc2[j].fechaVencimiento)
            let net = this.decimal(this.cxc2[j].idVenta.total)
            if (!this.cxc2[j].idVenta.observacion || this.cxc2[j].idVenta.observacion === '') {
              contenido.push({
                numF: this.cxc2[j].numFactura,
                fechaR: fechaRe,
                fechaV: fechaVe,
                diasD: this.cxc2[j].moroso,
                observacion: '',
                neto: net,
                saldo: this.cxc2[j].debito
              })
            } else {
              contenido.push({
                numF: this.cxc2[j].numFactura,
                fechaR: fechaRe,
                fechaV: fechaVe,
                diasD: this.cxc2[j].moroso,
                observacion: this.cxc2[j].idVenta.observacion,
                neto: net,
                saldo: this.cxc2[j].debito
              })
            }
          }
        }

        let acum = 0
        let acumNeto2 = 0
        for (let k = 0; k < contenido.length; k++) {
          const ac = parseFloat(contenido[k].saldo)
          this.decimal(ac)
          acum += ac

          const dc = parseFloat(contenido[k].neto)
          this.decimal(dc)
          acumNeto2 += dc
        }

        contenido.push({
          // numF: this.cliente[i].nombre,
          neto: 'TOTAL :',
          saldo: acum.toFixed(2)
        })

        let head = [
          [
            { content: this.rutaCliVen[i].rif + '    ' + this.rutaCliVen[i].nombre, colSpan: 7, styles: { halign: 'left', fillColor: [255, 255, 255], lineWidth: 0 } }
          ],
          columns
        ]
        acumNeto += acumNeto2
        acumTotal += acum

        // doc.text(50, doc.autoTableEndPosY() + 35, this.rutaCliVen[i].nombre)

        doc.setFontSize(10)
        doc.setFont('helvetica')
        doc.setFontType('bold')
        doc.text(50, 35, 'Cuentas por cobrar por clientes')
        doc.text(50, 49, 'Fecha de Emisión: ' + date)
        doc.text(350, 35, 'Vendedor: ' + this.editedItem.nombre + '  ' + this.editedItem.apellido + '   ' + 'C.I.: ' + this.editedItem.cedula)
        doc.text(350, 49, 'Ruta: ' + this.editedItem.codRuta.descripcion)

        if (contenido.length > 1) {
          doc.autoTable(columns, contenido, {
            theme: 'grid',
            margin: { top: 80 },
            styles: { lineWidth: 0, lineColor: 10, font: 'helvetica', fontStyle: 'bold', textColor: 20, fontSize: 8 },
            pageBreak: 'avoid',
            head: head,
            didParseCell: function (data) {
              var rows = data.table.body
              if (data.row.index === rows.length - 1 && data.column.dataKey === 'saldo') {
                data.cell.styles.lineWidth = 1
              }
            },
            headStyles: { fillColor: [255, 255, 255], lineWidth: 1 }
            // startY: doc.autoTableEndPosY() + 40
          })
        }

        acum = 0
        contenido = []
      }

      // doc.text(660, 49, 'Total a cobrar: ' + acumTotal.toFixed(2))

      contenido.push({
        numF: 'TOTAL GENERAL',
        neto: acumNeto.toFixed(2),
        saldo: acumTotal.toFixed(2)
      })
      doc.autoTable(columns, contenido, {
        theme: 'plain',
        margin: { top: 100 },
        styles: { lineWidth: 0, lineColor: 10, fillColor: [192, 192, 192], font: 'helvetica', fontStyle: 'bold', textColor: 20, fontSize: 8 },
        showHead: 'never'
        // pageBreak: 'avoid'
      })

      doc.setProperties({
        title: 'Factura'
      })
      doc.output('dataurlnewwindow')
    },

    initialize () {
      this.listarVendedores()
      this.listarClientes()
      this.listarCuentasXCobrar()
      /* this.listarRutas();
      this.listarPortafolios(); */
      this.permisosRuta = this.$store.state.empresa[0].permisos.find(
                         permiso => permiso.ruta == "Vendedor"
      );
    },

    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },

    validarModificar () {
      return this.permisosRuta?.accion.includes("Modificar");
    },

    validarEliminar () {
      return this.permisosRuta?.accion.includes("Eliminar");
    },

    listarVendedores () {
      Api.get('empleado/vendedores2')
        .then(res => {
          this.vendedor = res.data
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    listarClientes () {
      Api.get('/cliente')
        .then(response => {
          this.cliente = response.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    /* listarCuentasXCobrar () {
      Api.get('cuentaporcobrar')
        .then(response => {
          this.cxc = response.data
          // this.clientesVen(response.data)
          this.loading = false
        })
        .catch(e => {
          console.log('error' + e)
          this.permissDenied(e.response.status)
        })
    }, */

    clientesVen (editedItem) {
      let deuda = 0
      for (let i = 0; i < this.cliente.length; i++) {
        let cli = { id: '', rif: '', nombre: '', deuda: 0 }
        for (let j = 0; j < this.cxc.length; j++) {
          if (this.cliente[i]._id === this.cxc[j].idCliente._id) {
            let debi = parseFloat(this.cxc[j].debito)
            this.decimal(debi)
            deuda += debi
            /* console.log('DEUDA')
            console.log(deuda) */
          }
        }
        if (!this.cliente[i].idRuta || this.cliente[i].idRuta === '') {
          this.cliente[i].idRuta = []
        } else {
          if (this.editedItem.codRuta._id === this.cliente[i].idRuta._id) {
            cli.id = this.cliente[i]._id
            cli.rif = this.cliente[i].rif
            cli.nombre = this.cliente[i].nombre
            let de = this.decimal(deuda)
            cli.deuda = de
            this.rutaCliVen.push(cli)
          }
        }
        deuda = 0
      }

      for (let k = 0; k < this.rutaCliVen.length; k++) {
        for (let i = 0; i < this.cxc.length; i++) {
          if (this.rutaCliVen[k].id === this.cxc[i].idCliente._id) {
            this.cxc2.push(this.cxc[i])
          }
        }
      }

      if (this.rutaCliVen.length > 0) {
        this.mostrar = true
      } else {
        this.mostrar = false
      }
    },

    listarCuentasXCobrar () {
      Api.get('cuentaporcobrar')
        .then(response => {
          this.cxc = response.data
          // this.clientesCXC(response.data)
          let hoy = new Date()
          let moroso
          this.cxc.map((data, i) => {
            if (data.debito === 0) {
              this.cxc[i].estatusPago = 'Cancelada'
            } else {
              this.cxc[i].estatusPago = 'Pendiente'
            }
            data.fechaRegistro = this.formato(data.fechaRegistro)
            data.fechaVencimiento = this.formato(data.fechaVencimiento)
            data.fechaCierreFactura = this.formato(data.fechaCierreFactura)
            let fecha = this.$moment(hoy)
            let fecha2 = this.$moment(data.fechaVencimiento)
            moroso = fecha.diff(fecha2, 'days')
            if (moroso <= 0) this.cxc[i].moroso = 0
            else this.cxc[i].moroso = moroso
            data.debito = this.decimal(data.debito)
            data.credito = this.decimal(data.credito)
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    /* clientesCXC (cxc) {
      cxc.map(data => {
        if (this.cliente.length === 0) {
          this.cliente.push(data.idCliente)
        } else {
          let bool = false
          for (let i = 0; i < this.cliente.length; i++) {
            if (data.idCliente._id !== this.cliente[i]._id) {
              bool = true
            } else {
              bool = false
              break
            }
          }
          if (bool) {
            this.cliente.push(data.idCliente)
          }
        }
      })
    }, */

    formato (fecha) {
      return fecha.substr(0, 10)
    },

    formato2 (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY')
    },

    decimal (val) {
      return Number.parseFloat(val).toFixed(2)
    },

    /* listarRutas(){
      Api.get("/ruta")
        .then(response => {
          this.ruta = response.data;
          this.ruta.map(data => {
            this.idRutaArray.push({
              text: data.nombre,
              value: data._id
              });
          });
          console.log("Cargando Rutas");
          console.log(this.idRutaArray)
        })
        .catch(e => {
          console.log("error" + e);
        });
    },

    listarPortafolios(){
      Api.get("/portafolio")
        .then(response => {
          this.portafolio = response.data;
          this.portafolio.map(data => {
            this.idPortafolioArray.push({
              text: data.descripcion,
              value: data._id
              });
          });
          console.log("Cargando Portafolios");
          console.log(this.idPortafolioArray)
        })
        .catch(e => {
          console.log("error" + e);
        });
    }, */

    editItem (item, bool) {
      this.editedIndex = this.vendedor.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.clientesVen(item)
      this.dialog = true
      this.dialog2 = true
      this.read = bool
    },

    /* deleteItem(item) {
      console.log(item);
      const index = this.vendedor.indexOf(item);
      this.$swal({
        icon: "warning",
        title: "¿Seguro que quiere borrar?",
        text: "No podrá revertir",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "cancelar"
      }).then(result => {
        if (result.value) {
          this.$swal("Borrado!", "Su registro fue borrado.", "success");
          this.vendedor.splice(index, 1);
          Api.put("/vendedor/deletelog/" + item._id).then(response => {
            console.log(response);
          });
        }
      });
    }, */

    close () {
      this.dialog = false
      this.dialog2 = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        // this.editedItem.codPortafolio = []
        this.cxc2 = []
        this.rutaCliVen = []
        this.read = false
      }, 300)
    },

    /* validarCampos() {
      if (
           this.editedItem.cedula == ""        ||
           this.editedItem.apellido == ""      ||
           this.editedItem.nombre == ""        ||
           this.editedItem.codZona == ""       ||
           this.editedItem.codPortafolio == ""
         ) {
        this.$swal({
          icon: "error",
          title: "Formulario incompleto",
          text: "Por favor llene todos los campos para continuar"
        });
        return true;
      } else
      if (this.editedItem.nombre.length > 20) {
        this.$swal({
          icon: "error",
          title: "Error!",
          text: "Ha excedido el limite de caracteres"
        });
        return true;
      }
      return false;
    }, */

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    }

    /* save() {
      if (!this.validarCampos()) {
        if (this.editedIndex > -1) {
          Api.put("/vendedor", this.editedItem)
            .then(response => {
              console.log(response);
              this.$swal({
                icon: "success",
                title: "Modificacion exitosa",
                text: "Todos los cambios han sido efectuados"
              });
            })
            .catch(e => {
              this.$swal({
                icon: "error",
                title: "Error al modificar",
                text: "Por favor, verifique los datos e intente de nuevo"
              });
            });
          Object.assign(this.vendedor[this.editedIndex], this.editedItem);
        } else {
          console.log("Datos modificados");
          console.log(this.editedItem);

          Api.post("vendedor", this.editedItem)
            .then(response => {
              console.log(response);
              this.$swal({
                icon: "success",
                title: "Inclusion exitosa",
                text: "Todos los datos han sido guardados"
              });
               this.vendedor.push(response.data);

            })
            .catch(e => {
              console.log("error" + e);
              this.$swal({
                icon: "error",
                title: "Error al guardar",
                text: "Por favor, verifique los datos e intente de nuevo"
              });
            });
        }
        console.log("Datos guardados");
        this.listarVendedores();
        this.close();
      }
    } */
  }
}
</script>
